// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","container":"Container_container__cKI53","-large":"Container_-large__ti0nX"};